import React, { useState } from 'react';
import { Button } from './ui/button';
import { Grid3x3 } from 'lucide-react';

const DIGITS = ['1','2','3','4','5','6','7','8','9','*','0','#'];

/**
 * Reusable DTMF keypad with toggle button.
 * Props:
 *   call         - Telnyx call object with .dtmf(digit) method
 *   disabled     - disable when call is not active
 *   wrapperClass - optional extra class on the outer wrapper div
 */
export default function DTMFKeypad({ call, disabled = false, wrapperClass = '' }) {
  const [show, setShow] = useState(false);
  const [input, setInput] = useState('');

  const sendDigit = (digit) => {
    if (!call) return;
    try {
      call.dtmf(digit);
      setInput(prev => (prev + digit).slice(-12));
    } catch (e) {
      console.log('DTMF error:', e);
    }
  };

  return (
    <div className={wrapperClass}>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setShow(v => !v)}
        disabled={disabled}
        className={`flex items-center gap-2 ${show ? 'bg-indigo-50 text-indigo-600 border-indigo-200' : ''}`}
        data-testid="keypad-btn"
      >
        <Grid3x3 className="h-4 w-4" />
        Keypad
      </Button>

      {show && !disabled && (
        <div className="mt-3 border-t pt-3">
          <div className="mb-2 h-7 bg-slate-100 rounded text-center font-mono text-sm text-slate-700 flex items-center justify-center tracking-widest">
            {input || <span className="text-slate-400 text-xs">keypad</span>}
          </div>
          <div className="grid grid-cols-3 gap-1">
            {DIGITS.map(d => (
              <button
                key={d}
                onClick={() => sendDigit(d)}
                className="h-10 rounded-md bg-slate-100 hover:bg-indigo-100 hover:text-indigo-700 text-slate-700 font-semibold text-sm transition-colors active:scale-95"
                data-testid={`dtmf-${d}`}
              >
                {d}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
